<div class="createAlertMobile__cont" *ngIf="isMobile">
  <div class="createAlertMobile__header">
    <app-ds-header
      [widgetConfig]="headerWidgets"
      [isTransparent]="true"
      (clickAction)="close()">
    </app-ds-header>
  </div>
  <div class="container-alert">
    <div class="description">
      <app-ds-typography
        [size]="typographyFontSize.XS"
        [color]="typographyFontColor.Primary"
        [text]="'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.DESCRIPTION_ALERT' | transloco">
      </app-ds-typography>
    </div>
    <div class="container-search">
      <app-search-bar
        [searchType]="searchType"
        [isMobile]="true"
        [airports]="airports$ | async"
        [validate]="validate"
        (showMobileCalendarEvent)="showMobileCalendar($event)">
      </app-search-bar>
    </div>
    <div class="container-form-alert">
      <div class="config-alert-title">
        <app-ds-typography
          [size]="typographyFontSize.XXS"
          [color]="typographyFontColor.Primary"
          [fontFamily]="typographyFontFamily.SemiBold"
          [text]="'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.CONFIG_ALERT' | transloco">
        </app-ds-typography>
      </div>
      <div class="actions" *ngIf="!!priceForm">
        <app-form-currency-input
          [style]="'alert'"
          [form]="priceForm"
          [formControlSelector]="priceItemForm"
          [id]="priceItemForm"
          [isSubmitted]="isSubmitted"
          [placeholder]="
            'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.PRICE_PLACEHOLDER' | transloco
          "
        >
        </app-form-currency-input>
      </div>
      <div class="actions check-list">
        <fieldset class="input">
          <app-ds-checkbox
            [align]="alignCheckboxes.Right"
            [checked]="directOnly"
            [title]="{ Label: 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.DIRECT_FLIGHTS' | transloco }"
            (checkboxOnChecked)="setDirectOnly()">
          </app-ds-checkbox>
        </fieldset>
        <fieldset class="input last">
          <app-ds-checkbox
            [align]="alignCheckboxes.Right"
            [checked]="flexDates"
            [title]="{ Label: 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.FLEX_DATES' | transloco }"
            (checkboxOnChecked)="setFlexDates()">
          </app-ds-checkbox>
        </fieldset>
      </div>
    </div>
  </div>

  <div class="create-button">
    <app-fixed-surface [boxShadow]="true">
      <app-ds-button
        [isLoading]="isLoadingCreateAlert$ | async"
        [labels]="{ ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.SAVE_ALERT_PRICE' | transloco }"
        (clickEvent)="createAlert()">
      </app-ds-button>
    </app-fixed-surface>
  </div>
</div>

<app-swipe-up
  [height]="75"
  [showSwipeUp]="createAlertModal"
  [title]="'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.ALERT_CREATED' | transloco"
  [showHeader]="true"
  (toggleShowSwipeUp)="toggleCreateAlertModal()">
  <ng-container content>
    <div class="createAlertMobile__modal">
      <div class="createAlertMobile__modal--info">
        <div class="createAlertMobile__modal--content">
          <app-ds-typography
            class="text-message"
            [size]="typographyFontSize.XS"
            [color]="typographyFontColor.Primary"
            [text]="'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.DESCRIPTION_ALERT' | transloco">
          </app-ds-typography>
          <div class="createAlertMobile__modal--content__info">
            <div class="createAlertMobile__modal--content__info__row-info">
              <div class="createAlertMobile__modal--content__info__row-info__box-left">
                <div class="title-info">
                  <app-ds-typography
                    [size]="typographyFontSize.Minor"
                    [color]="typographyFontColor.Secondary"
                    [text]="'GENERAL_WIDGET_MODULE.ALERTS.DELETE.INFO.DESTINATION' | transloco">
                  </app-ds-typography>
                </div>
                <div class="value">
                  <app-ds-typography
                    [size]="typographyFontSize.XXS"
                    [text]="createAlertData?.departure_name + ' - ' + createAlertData?.arrival_name"
                    [color]="typographyFontColor.Primary">
                  </app-ds-typography>
                </div>
              </div>
              <div class="createAlertMobile__modal--content__info__row-info__box-right">
                <div class="title-info">
                  <app-ds-typography
                    [size]="typographyFontSize.Minor"
                    [color]="typographyFontColor.Secondary"
                    [text]="'GENERAL_WIDGET_MODULE.ALERTS.DELETE.INFO.DATES' | transloco">
                  </app-ds-typography>
                </div>
                <div class="value">
                  <app-ds-typography
                    [size]="typographyFontSize.XXS"
                    [color]="typographyFontColor.Primary"
                    [text]="
                      createAlertData?.flex_dates ?
                      (
                        createAlertData?.oneway ?
                        (createAlertData?.outbound_min | date: 'd MMM' | dateFormat) + ', ' + (createAlertData?.outbound_max | date: 'd MMM' | dateFormat) : 
                        (createAlertData?.outbound_min | date: 'd MMM' | dateFormat) + ', ' + (createAlertData?.outbound_max | date: 'd MMM' | dateFormat)
                        + '&lt;br&gt;' +
                        (createAlertData?.inbound_min | date: 'd MMM' | dateFormat) + ', ' + (createAlertData?.inbound_max | date: 'd MMM' | dateFormat)
                      )
                      :
                      (
                        createAlertData?.oneway ?
                        (createAlertData?.outbound_max | date: 'd MMM' | dateFormat) : 
                        (createAlertData?.outbound_min | date: 'd MMM' | dateFormat) + ' - ' + (createAlertData?.inbound_max | date: 'd MMM' | dateFormat)
                      )
                    ">
                  </app-ds-typography>
                </div>
              </div>
            </div>
            <div class="createAlertMobile__modal--content__info__row-info">
              <div class="createAlertMobile__modal--content__info__row-info__box-left">
                <div class="title-info">
                  <app-ds-typography
                    [size]="typographyFontSize.Minor"
                    [color]="typographyFontColor.Secondary"
                    [text]="'GENERAL_WIDGET_MODULE.ALERTS.DELETE.INFO.FLIGHTS' | transloco">
                  </app-ds-typography>
                </div>
                <div class="value">
                  <app-ds-typography
                    [size]="typographyFontSize.XXS"
                    [color]="typographyFontColor.Primary"
                    [text]="directOnly ? ('GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.DIRECT_ONLY' | transloco) : ('GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.WITH_SCALES' | transloco)">
                  </app-ds-typography>
                </div>
              </div>
              <div class="createAlertMobile__modal--content__info__row-info__box-right">
                <div class="title-info">
                  <app-ds-typography
                    [size]="typographyFontSize.Minor"
                    [color]="typographyFontColor.Secondary"
                    [text]="'GENERAL_WIDGET_MODULE.ALERTS.DELETE.INFO.NEAR_DATES' | transloco">
                  </app-ds-typography>
                </div>
                <div class="value">
                  <app-ds-typography
                    [size]="typographyFontSize.XXS"
                    [color]="typographyFontColor.Primary"
                    [text]="flexDates ? ('GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.INCLUDED' | transloco) : ('GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.NOT_INCLUDED' | transloco)">
                  </app-ds-typography>
                </div>
              </div>
            </div>
            <div class="createAlertMobile__modal--content__info__row-info">
              <div class="createAlertMobile__modal--content__info__row-info__box-left">
                <div class="title-info">
                  <app-ds-typography
                    [size]="typographyFontSize.Minor"
                    [color]="typographyFontColor.Secondary"
                    [text]="'GENERAL_WIDGET_MODULE.ALERTS.DELETE.INFO.PRICER_PER_PERSON_UNDER' | transloco">
                  </app-ds-typography>
                </div>
                <div class="value" *ngIf="priceValue">
                  <app-ds-typography
                    [size]="typographyFontSize.XXS"
                    [color]="typographyFontColor.Primary"
                    [text]="priceValue | currencyFormat: currencyCode">
                  </app-ds-typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="createAlertMobile__accept-button">
        <app-fixed-surface>
          <app-ds-button
            [labels]="{ ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.ACCEPT' | transloco }"
            (clickEvent)="redirectToListAlerts()">
          </app-ds-button>
        </app-fixed-surface>
      </div>
    </div>
  </ng-container>
</app-swipe-up>

<app-swipe-up
  [height]="75"
  [title]="'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.ALERT_NOT_CREATED' | transloco"
  [showHeader]="true"
  [showSwipeUp]="createAlertWarning"
  (toggleShowSwipeUp)="toggleCreateAlertWarning()">
  <ng-container content>
    <div class="createAlertMobile__modal">
      <div class="createAlertMobile__modal--info createAlertMobile__modal--info--exit">
        <div class="createAlertMobile__modal--content createAlertMobile__modal--info--exit">
          <div class="text-question">
            <app-ds-typography
              [size]="typographyFontSize.XS"
              [fontFamily]="typographyFontFamily.SemiBold"
              [color]="typographyFontColor.Primary"
              [text]="'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.ALERT_QUESTION_CLOSE' | transloco">
            </app-ds-typography>
          </div>
          <div class="text-description">
            <app-ds-typography
              [size]="typographyFontSize.XS"
              [color]="typographyFontColor.Primary"
              [text]="'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.ALERT_DESCRIPTION_CLOSE' | transloco">
            </app-ds-typography>
          </div>
        </div>
      </div>
      <div class="createAlertMobile__buttons">
        <app-fixed-surface>
          <div class="createAlertMobile__buttons--accept">
            <app-ds-button
              [labels]="{ ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.ALERT_CREATE_CLOSED' | transloco }"
              (clickEvent)="redirectToHome()">
            </app-ds-button>
          </div>
          <div class="createAlertMobile__buttons--closed">
            <app-ds-button
              [type]="closedButtonType"
              [labels]="{ ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.ALERT_RETURN' | transloco }"
              (clickEvent)="toggleCreateAlertWarning()">
            </app-ds-button>
          </div>
        </app-fixed-surface>
      </div>
    </div>
  </ng-container>
</app-swipe-up>

<app-swipe-up
  [height]="75"
  [showSwipeUp]="alertRepeatedAlert"
  [title]="'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.ALERT_NOT_CREATED' | transloco"
  [showHeader]="true"
  (toggleShowSwipeUp)="toggleAlertRepeated()">
  <ng-container content>
    <div class="createAlertMobile__modal">
      <div class="createAlertMobile__modal--info createAlertMobile__modal--info--warning">
        <div class="createAlertMobile__modal--content">
          <div class="text-description">
            <app-ds-typography
              [size]="typographyFontSize.XS"
              [color]="typographyFontColor.Primary"
              [text]="'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.ALERT_REPEATED' | transloco">
            </app-ds-typography>
          </div>
        </div>
      </div>
      <div class="createAlertMobile__accept-button">
        <app-fixed-surface>
          <app-ds-button
            [labels]="{ ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.ACCEPT' | transloco }"
            (clickEvent)="toggleAlertRepeated()">
          </app-ds-button>
        </app-fixed-surface>
      </div>
    </div>
  </ng-container>
</app-swipe-up>
<router-outlet name="detail"> </router-outlet>
